export const getImageUrl = (image_url: string) => {
  if (!image_url) {
    return null;
  }
  const config = useRuntimeConfig();

  if (image_url.startsWith("/")) {
    return config.public.imageUrl + image_url;
  } else if (image_url.startsWith("http")) {
    return image_url;
  } else {
    return config.public.imageUrl + "/" + image_url;
  }
};

export const getUploadImageUrl = (image_url: string) => {
  if (!image_url) {
    return null;
  }
  const config = useRuntimeConfig();

  if (image_url.startsWith("/")) {
    return config.public.uploadUrl + image_url;
  } else if (image_url.startsWith("http")) {
    return image_url;
  } else {
    return config.public.uploadUrl + "/" + image_url;
  }
};
